import React from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaCheckCircle } from "react-icons/fa";

const features = [
  "Tailored Solutions",
  "Experienced Team",
  "Trusted Global Network",
  "Reliable Delivery",
];

function WhyChooseLozrian(props) {
  return (
    <Row className="justify-content-center" id="about">
      <Col md={10}>
        <Row className="align-items-center minHeight-85 mt-n-5">
          <Col lg={6} className="WhyChooseLozrian-content">
            <h1 id="id_h1WhyChooseLozrian">
              Why Choose <br />
              Lozrian?
            </h1>
            <p id="id_Lozrian_p1">
              One partner, multiple solutions. Whether you're building
              software, expanding your business, or sourcing products
              globally, Lozrian provides integrated solutions backed by
              experienced professionals and trusted partnerships.
            </p>
            <ul className="WhyChooseLozrian-features">
              {features.map((feature) => (
                <li key={feature}>
                  <FaCheckCircle />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={6} className="WhyChooseLozrianContentImg d-lg-block d-none">
            <img
              src="/img/WhyChooseLozrian.svg"
              alt="WhyChooseLozrian"
              className="WhyChooseLozrian"
            />
          </Col>
          <Col lg={6} className="WhyChooseLozrianContentImg d-block d-lg-none">
            <img
              src="/img/WhyChooseLozrian.svg"
              alt="WhyChooseLozrian"
              className="WhyChooseLozrian"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default WhyChooseLozrian;
